// extracted by mini-css-extract-plugin
export default {"wrapper":"Cart_wrapper__VFbne","header":"Cart_header__iV38O","content":"Cart_content__D87M6","info":"Cart_info__JsnC+","billing":"Cart_billing__j1PFv"};